import type { PostFeedTypeFeature } from '@/features/feature-management/types/postTypeFeature';
import { useGetPostTypeFeature } from '@/features/post-editor/hooks/useGetPostFeature';
import { PostFeedType } from '@/features/posts/types/postFeed';

export const useGetPostFeedTypeFeatures = () => {
  const postTypeFeatures: PostFeedTypeFeature[] = [
    {
      type: PostFeedType.GOSSIP,
      ...useGetPostTypeFeature(PostFeedType.GOSSIP)
    },
    {
      type: PostFeedType.NEWS_ITEM,
      ...useGetPostTypeFeature(PostFeedType.NEWS_ITEM)
    },
    {
      type: PostFeedType.EMERGENCY,
      ...useGetPostTypeFeature(PostFeedType.EMERGENCY)
    },
    {
      type: PostFeedType.HAPPENING,
      ...useGetPostTypeFeature(PostFeedType.HAPPENING)
    },
    {
      type: PostFeedType.MARKET,
      ...useGetPostTypeFeature(PostFeedType.MARKET)
    },
    {
      type: PostFeedType.SUGGESTION,
      ...useGetPostTypeFeature(PostFeedType.SUGGESTION)
    },
    {
      type: PostFeedType.SPECIAL_POST,
      ...useGetPostTypeFeature(PostFeedType.SPECIAL_POST)
    }
  ];

  return postTypeFeatures
    .filter((entry) => entry.enabled === true)
    .sort((a, b) => a.orderValue - b.orderValue);
};
